import type { GapProps, GridItemProps } from '../extensions';
import { gap, gridItem } from '../extensions';
import styledFactory from '../styledFactory';

export type Props = GridItemProps & GapProps;

/**
 * A convenience component for flexbox layouts.
 */
const FlexBox = styledFactory<Props, 'div'>(
  'div',
  'FlexBox',
  undefined,
  [gap, gridItem],
  undefined,
  {
    display: 'flex',
  },
);

/**
 * A convenience component for inline flexbox layouts.
 */
const FlexBoxInline = styledFactory<Props, 'div'>(
  'div',
  'FlexBox',
  undefined,
  [gap, gridItem],
  undefined,
  {
    display: 'inline-flex',
  },
);

export default Object.assign(FlexBox, { inline: FlexBoxInline });
